/**
 * 搬入・引取にて紐付けされたマニフェスト
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../constants/httpConst'
 import * as types from '../../../mutation-types/driver-types'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/map_requests`

 const getDefaultState = () => {
   return {
     pagination: {
       current_page: 1,
       total_count: 0
     },
   }
 }
 const manifest_map_request = {
   namespaced: true,
   state: getDefaultState(),
   getters: {
     hasResult: ( state ) => {
       return (state.pagination.total_count > 0)
     },
   },
   actions: {
     index ({ dispatch, commit, state }, {search_type, order_id, trader_location_code, transport_id, trader_id, limit, page}) {
       dispatch('saveCondition', {
         search_type: search_type,
         order_id: order_id,
         trader_location_code: trader_location_code,
         transport_id: transport_id,
         trader_id: trader_id,
       })
       const params = {
         search_type: state.search_type,
         order_id: state.order_id,
         trader_location_code: state.trader_location_code,
         transport_id: state.transport_id,
         trader_id: state.trader_id,
         limit: limit,
         page: page
       }
       return new Promise((resolve) => {
         Vue.$http.get(API_PATH, { params: params }).then(data => {
         let content = data.content
         commit(types.DRIVER_MANIFEST_MAP_REQUEST_PAGINATION, { content })
         resolve(content)
         })
       })
     },


     saveCondition ({ commit, state }, {
      search_type, order_id,trader_location_code,transport_id, trader_id
     }) {
       const _search_type = (search_type !== undefined) ? search_type: state.condition.search_type
       const _order_id = (order_id !== undefined) ? order_id: state.condition.order_id
       const _trader_location_code = (trader_location_code !== undefined) ? trader_location_code: state.condition.trader_location_code
       const _transport_id = (transport_id !== undefined) ? transport_id: state.condition.transport_id
       const _trader_id = (trader_id !== undefined) ? trader_id: state.condition.trader_id
       const params = {
         search_type: _search_type,
         order_id: _order_id,
         trader_location_code: _trader_location_code,
         transport_id: _transport_id,
         trader_id: _trader_id,
       }
       commit(types.DRIVER_MANIFEST_MAP_REQUEST_CONDITION, { params })
     },
     resetState ({ commit }) {
       commit(types.DRIVER_MANIFEST_MAP_REQUEST_RESET_CONDITION)
     },
     resetPagination ({ commit }) {
       commit(types.DRIVER_MANIFEST_MAP_REQUEST_RESET_PAGINATION)
     },
   },
   mutations: {
     /**
      * ページ情報の設定
      * @param state
      * @param content
      */
     [types.DRIVER_MANIFEST_MAP_REQUEST_PAGINATION] (state, { content }) {
       state.pagination = content.pagination
     },
     /**
      * ページ情報のリセット
      * @param state
      */
     [types.DRIVER_MANIFEST_MAP_REQUEST_RESET_PAGINATION] (state) {
       Object.assign(state.pagination, getDefaultState().pagination)
     },
     /**
      * 検索条件の設定
      * @param state
      * @param params
      */
     [types.DRIVER_MANIFEST_MAP_REQUEST_CONDITION] (state, { params }) {
       state.search_type = params.search_type,
       state.order_id = params.order_id,
       state.trader_location_code = params.trader_location_code,
       state.transport_id = params.transport_id,
       state.trader_id = params.trader_id
     },
     /**
      * 検索条件のリセット
      * @param state
      */
     [types.DRIVER_MANIFEST_MAP_REQUEST_RESET_CONDITION] (state) {
       Object.assign(state, getDefaultState())
     },
   },

 }

export default manifest_map_request
